export { default as PaymentMethods } from './PaymentMethods';
